import api from './axiosConfig';
// 서버 연결 확인 플래그
let useRealDB = true;
// DB 연결 확인
const checkDBConnection = async () => {
    try {
        await api.get('/api/health-check');
        useRealDB = true;
        return true;
    }
    catch (error) {
        console.error('데이터베이스 연결 실패, Mock 데이터를 사용합니다:', error);
        useRealDB = false;
        return false;
    }
};
// 초기화 시 연결 확인
checkDBConnection();
// 상품 Mock 데이터
const mockProducts = [
    {
        id: 'P001',
        barcode: '1234567890',
        product_code: 'P001',
        product_name: '테스트 상품 1',
        courier_company: '1',
        courier_fee: '01',
        deliver_qty: '10',
        depth: '1',
        height: '1',
        optimal_stock_level: '01',
        weight: '1',
        width: '1',
        recommend_rack: 'A-1-1',
        createDate: '2023-10-01'
    }
];
// 필터 함수
const filterMockProducts = (page = 1, limit = 10, searchTerm, status, startDate, endDate) => {
    let filteredProducts = [...mockProducts];
    if (searchTerm) {
        filteredProducts = filteredProducts.filter(item => item.product_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.product_name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedProducts = filteredProducts.slice(startIndex, endIndex);
    return {
        items: paginatedProducts,
        totalCount: filteredProducts.length,
        page,
        pageSize: limit,
        totalPages: Math.ceil(filteredProducts.length / limit)
    };
};
// 상품 목록 조회
export const getProducts = async (page = 1, limit = 10, searchTerm, status, startDate, endDate) => {
    try {
        const response = await api.get('/api/products', {
            params: { page, limit, searchTerm, status, startDate, endDate }
        });
        return response.data;
    }
    catch (error) {
        console.error('상품 목록 조회 오류:', error);
        return {
            success: true,
            data: filterMockProducts(page, limit, searchTerm, status, startDate, endDate),
            message: 'Mock 데이터 조회 성공'
        };
    }
};
// 상품 상세 조회
export const getProductById = async (id) => {
    try {
        const response = await api.get(`/api/products/${id}`);
        return response.data;
    }
    catch (error) {
        const product = mockProducts.find(item => item.id === id);
        return {
            success: true,
            data: product || null,
            message: 'Mock 데이터 조회 성공'
        };
    }
};
// 상품 생성
export const createProduct = async (product) => {
    try {
        const response = await api.post('/api/products', product);
        return response.data;
    }
    catch (error) {
        console.error('상품 생성 오류:', error);
        throw error;
    }
};
// 상품 수정
export const updateProduct = async (id, product) => {
    try {
        const response = await api.get(`/api/products/${id}/update`, { params: product });
        return response.data;
    }
    catch (error) {
        console.error('상품 수정 오류:', error);
        throw error;
    }
};
// 상품 삭제
export const deleteProduct = async (id) => {
    try {
        const response = await api.delete(`/api/products/${id}`);
        return response.data;
    }
    catch (error) {
        console.error('상품 삭제 오류:', error);
        throw error;
    }
};
// 상품 일괄 등록
export const bulkCreateProducts = async (products) => {
    try {
        const response = await api.post('/api/products/bulk', products);
        return response.data;
    }
    catch (error) {
        console.error('상품 일괄 등록 오류:', error);
        throw error;
    }
};
// 상품 엑셀 다운로드
export const exportProductsToExcel = async (filters) => {
    try {
        const response = await api.get('/api/products/export', {
            params: filters,
            responseType: 'blob'
        });
        return response.data;
    }
    catch (error) {
        console.error('상품 엑셀 내보내기 오류:', error);
        throw error;
    }
};
// 상품 엑셀 업로드 템플릿 다운로드
export const downloadProductExcelTemplate = async () => {
    try {
        const response = await api.get('/api/products/template', { responseType: 'blob' });
        return response.data;
    }
    catch (error) {
        console.error('상품 엑셀 템플릿 다운로드 오류:', error);
        throw error;
    }
};
// 엑셀 파일에서 상품 가져오기
export const importProductsFromExcel = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post('/api/products/import', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    }
    catch (error) {
        console.error('상품 엑셀 가져오기 오류:', error);
        throw error;
    }
};
